import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

export default async function markAllNotifiationsAsReaded() {
  const response = await institutionAPI({
    method: 'PATCH',
    url: '/notification/notification/notification/all-open',
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
